"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("@emotion/react");

var _theme = _interopRequireWildcard(require("../../theme/theme"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Card = function Card(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "left" : _ref$align,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "2" : _ref$padding;

  var space = _theme.MAP_SPACE[String(padding)];

  return (0, _react.jsx)("div", {
    className: className,
    css: (0, _react.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        padding: ", ";\n        border: ", " solid ", ";\n        border-radius: ", ";\n\n        box-shadow: 0 2px 7px -2px rgba(0, 0, 0, 0.6);\n        background: ", ";\n\n        text-align: ", ";\n        color: ", ";\n        font-size: ", ";\n        line-height: ", ";\n        font-family: ", ";\n\n        & + & {\n          margin-top: ", ";\n        }\n      "])), space, _theme["default"].borderSizeRegular, _theme["default"].colorDarkTemp, _theme["default"].radiusHeavy, _theme["default"].colorLightTemp, align, _theme["default"].colorDarkTemp, _theme["default"].fontSizeN, _theme["default"].lineHeightN, _theme["default"].fontFamily, _theme["default"].spaceOne)
  }, children);
};

Card.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  align: _propTypes["default"].oneOf(_theme.TEXT_ALIGN_TYPES),
  padding: _propTypes["default"].oneOf(_theme.SPACE_TYPES)
};
var _default = Card;
exports["default"] = _default;